import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "value", "checked", "disabled", "required"]
const _hoisted_3 = { class: "ui-radio__circle" }
const _hoisted_4 = {
  key: 0,
  class: "ui-radio__dot"
}
const _hoisted_5 = {
  key: 0,
  class: "ui-radio__text"
}
const _hoisted_6 = {
  key: 0,
  class: "ui-radio__helper"
}
const _hoisted_7 = {
  key: 0,
  class: "ui-radio__error"
}
const _hoisted_8 = {
  key: 1,
  class: "ui-radio__helper-text"
}

import { computed, ref } from "vue";
import type { Size } from "./types";

interface Props {
  modelValue?: string | number | boolean;
  value: string | number | boolean;
  name?: string;
  label?: string;
  size?: Size;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  helperText?: string;
  id?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Radio',
  props: {
    modelValue: { type: [String, Number, Boolean] },
    value: { type: [String, Number, Boolean] },
    name: {},
    label: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: {},
    helperText: {},
    id: {}
  },
  emits: ["update:modelValue", "blur", "focus", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isFocused = ref(false);
const radioId = computed(() => props.id || `radio-${Math.random().toString(36).substr(2, 9)}`);

const isChecked = computed(() => props.modelValue === props.value);

const wrapperClasses = computed(() => {
  const classes = ["ui-radio"];
  classes.push(`ui-radio--${props.size}`);
  if (props.disabled) classes.push("ui-radio--disabled");
  if (props.error) classes.push("ui-radio--error");
  return classes;
});

const radioClasses = computed(() => {
  const classes = ["ui-radio__input"];
  if (isFocused.value) classes.push("ui-radio__input--focused");
  return classes;
});

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.checked) {
    emit("update:modelValue", props.value);
    emit("change", props.value);
  }
};

const handleBlur = (event: FocusEvent) => {
  isFocused.value = false;
  emit("blur", event);
};

const handleFocus = (event: FocusEvent) => {
  isFocused.value = true;
  emit("focus", event);
};

const handleLabelClick = (event: MouseEvent) => {
  if (props.disabled) {
    event.preventDefault();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(wrapperClasses.value)
  }, [
    _createElementVNode("label", {
      for: radioId.value,
      class: "ui-radio__label",
      onClick: handleLabelClick
    }, [
      _createElementVNode("input", {
        id: radioId.value,
        type: "radio",
        name: __props.name,
        value: __props.value,
        checked: isChecked.value,
        disabled: __props.disabled,
        required: __props.required,
        class: _normalizeClass(radioClasses.value),
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus
      }, null, 42, _hoisted_2),
      _createElementVNode("span", _hoisted_3, [
        (isChecked.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      (__props.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    (__props.error || __props.helperText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (__props.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.error), 1))
            : (__props.helperText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.helperText), 1))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})